import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf'
import Alert from 'react-s-alert';
import moment from 'moment';
import '../GenerateQuotation/GenerateQuoteStyle.css';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import numberToEnglish from '../Common/CommonMethods';
import FailureAlert from '../Common/Failure';
import Barcode from 'react-barcode';
import Regions from '../Common/Region';
import Select from 'react-select';

const GeneratePO = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [RegionSymbol, setRegionSymbol] = useState({});
    const [companyInfo, setCompanyInfo] = useState([]);
    const [QuoationInfo, setQuoationInfo] = useState([]);
    const [QuoationData, setQuoationData] = useState([]);
    const [ProductsPDFInfo, setProductsPDFInfo] = useState([]);
    const [TotalAmountAndCustomerPDFInfo, setTotalAmountAndCustomerPDFInfo] = useState([]);
    const [SelectedQuotationPDFInfo, setSelectedQuotationPDFInfo] = useState(0);
    const [AmountwithoutGST, setAmountwithoutGST] = useState(0);
    const [TypePaymentValue, setTypePaymentValue] = useState("100% Advance");

    const FetchInitialData = () => {
        var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
        if (userData && localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }

            const userID = parseInt(JSON.parse(userData).ID);
            Axiosfetch(baseURL + "GetPurchaseOrderByStatus", "POST", { UserID: userID }, getQuotationsSuccess, Failure);
        }
        else {
            Alert.error("Error occured While Loading Quotations. Please login to the application again before attempting the steps.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const getQuotationsSuccess = (data) => {
        if (data.length > 0) {
            var PoData = [];
            setQuoationData(data);
            data.forEach(quotation => {
                let PONumber = "PO/" + (quotation.Customer ? quotation.Customer.Name.split(' ')[0].trim() : "") + "/#" +
                    quotation.ID + "/" + moment(quotation.CreatedDate).local().format("DDMMYYYY");
                PoData.push({ value: quotation.ID, label: PONumber });
            });

            setQuoationInfo(PoData);
        }
        else {
            setQuoationInfo([]);
            setQuoationData([]);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const CreateQuotationSnapShotSuccess = (data) => {
    };

    const CreateSnapshot = (imgData) => {
        Axiosfetch(baseURL + "CreatePOSnapShot", "POST", { POID: SelectedQuotationPDFInfo, ImageData: imgData }, CreateQuotationSnapShotSuccess, Failure);
    }

    const printPDF = () => {
        if (TypePaymentValue === "") {
            Alert.error("Terms and Condition Details are Missing", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return;
        }

        if (SelectedQuotationPDFInfo > 0) {
            const domElement = document.getElementById('page');
            html2canvas(domElement, {
                scale: 1.6
            })
                .then((canvas) => {
                    const imgData = canvas.toDataURL('image/png');
                    CreateSnapshot(imgData);
                    var imgWidth = 205;
                    var pageHeight = 295;
                    var imgHeight = canvas.height * imgWidth / canvas.width;
                    var heightLeft = imgHeight;
                    var doc = new jsPdf('p', 'mm');
                    var position = 2;

                    doc.addImage(imgData, 'PNG', 2, position, imgWidth, imgHeight, '', 'FAST');
                    heightLeft -= pageHeight;

                    while (heightLeft >= 0) {
                        position = heightLeft - imgHeight;
                        doc.addPage();

                        doc.addImage(imgData, 'PNG', 2, position, imgWidth, imgHeight, '', 'FAST');
                        heightLeft -= pageHeight;

                    }

                    doc.save('PO_' + (TotalAmountAndCustomerPDFInfo.Customer ? TotalAmountAndCustomerPDFInfo.Customer.Name.split(' ')[0].trim() : TotalAmountAndCustomerPDFInfo.ID) + "_" +
                        moment(TotalAmountAndCustomerPDFInfo.CreatedDate).local().format("DDMMYYYY") + '.pdf');
                });
        }
        else {
            Alert.error("Please Select Quotation.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const setQuotationIDCriteria = (POData) => {
        let POID = parseInt(POData ? POData.value : 0);
        if (POID > 0) {
            setSelectedQuotationPDFInfo(POID);
            var QuoationToGenerate = QuoationData.filter(q => q.ID === parseInt(POID));
            setTotalAmountAndCustomerPDFInfo(QuoationToGenerate[0]);
            Axiosfetch(baseURL + "getPurchaseOrderInfo", "POST", { ID: POID }, ProductDataSuccess, Failure);
        }
        else {
            setSelectedQuotationPDFInfo(0);
            setTotalAmountAndCustomerPDFInfo([]);
            setAmountwithoutGST(0);
        }
    };

    const ProductDataSuccess = (data) => {
        if (data.length > 0) {
            setProductsPDFInfo(data);
            let withoutGSTAmount = 0;
            data.forEach(value => {
                withoutGSTAmount += value.ProductQuantity * value.ProductPrice;
            });

            setAmountwithoutGST(withoutGSTAmount);
        }
    };

    const onTypePaymentChange = (value) => {
        setTypePaymentValue(value);
    };

    useEffect(() => {
        FetchInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-1 col-md-7 col-sm-7">
                        <div style={{ width: "60%" }}>
                            <Select isClearable={true} isSearchable={true} placeholder="Select PO"
                                options={QuoationInfo}
                                onChange={setQuotationIDCriteria}></Select>
                        </div>
                        {/* <div className="basic-select">
                            <select className="DropdownStyle" onChange={(e) => setQuotationIDCriteria(e.target.value)}>
                                <option value="0">Select PO</option>
                                {
                                    QuoationInfo.length > 0 && QuoationInfo.map(quotation => (
                                        <option key={quotation.ID} value={quotation.ID}>PO/{quotation.Customer ? quotation.Customer.Name.split(' ')[0].trim() : ""}/#{quotation.ID}/{moment(quotation.CreatedDate).local().format("DDMMYYYY")}</option>
                                    ))
                                }
                            </select>
                        </div> */}
                    </div>
                    <div className="col-md-4 col-sm-4 align-right">
                        <button className={`btn btn-Save ${CurrentTheme}Focus`} onClick={printPDF}>Generate PDF</button>
                    </div>

                </div>
                <hr></hr>
                {(SelectedQuotationPDFInfo > 0 && TotalAmountAndCustomerPDFInfo) && (<div className=""><div className="row" id="page">

                    <div className="col-md-12">
                        <div className="WaterMarkStyle" style={{ backgroundImage: "url('" + companyInfo.LogoWaterMark + "')" }}>
                            <div className="row GenerateQuoteTitleStyle">
                                <div className="col-xs-6 col-sm-6 col-md-6">
                                <div style={{ fontSize: "40px", color: "#005582", paddingLeft:"6px", fontWeight:"600" }}>PURCHASE ORDER</div>
                                    <Barcode width={1} height={35} displayValue={false}
                                        value={"PO/" + (TotalAmountAndCustomerPDFInfo.Customer ? TotalAmountAndCustomerPDFInfo.Customer.Name.split(' ')[0].trim() : "") + "/#" + TotalAmountAndCustomerPDFInfo.ID + "/" + moment(TotalAmountAndCustomerPDFInfo.CreatedDate).local().format("DDMMYYYY")}>
                                    </Barcode>
                                </div>
                                <div className="offset-md-2 col-xs-4 col-sm-4 col-md-4 align-right">
                                    {companyInfo.LogoHeader && (<div><img alt="Permium" className="WaterMarkStyle" style={{ height: "9rem", width: "10rem" }} src={companyInfo.LogoHeader}></img></div>)}
                                </div>
                                <div className="col-md-12" style={{ marginTop: "10px" }}>
                                    <h5><b>To,</b></h5>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-8 col-md-8">
                                            <p> {TotalAmountAndCustomerPDFInfo.Customer ? TotalAmountAndCustomerPDFInfo.Customer.Name : ""} </p>
                                            <p>{TotalAmountAndCustomerPDFInfo.Customer ? TotalAmountAndCustomerPDFInfo.Customer.Address : ""}</p>
                                            <p> <b>Tel : </b> {TotalAmountAndCustomerPDFInfo.Customer ? TotalAmountAndCustomerPDFInfo.Customer.PhoneNumber : ""}</p>
                                        </div>
                                        <div className="col-xs-12 col-sm-4 col-md-4">
                                            <div>
                                                <p style={{ textTransform: "uppercase" }}><b>{companyInfo.Name}</b></p>
                                                <p>{companyInfo.Address}</p>
                                                <p><b>{RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST"} : {companyInfo.GSTNumber}</b></p>
                                                <p><b> PO No. : PO/{TotalAmountAndCustomerPDFInfo.Customer ?
                                                    TotalAmountAndCustomerPDFInfo.Customer.Name.split(' ')[0].trim() : ""}/#{TotalAmountAndCustomerPDFInfo.ID}/{moment(TotalAmountAndCustomerPDFInfo.CreatedDate).local().format("DDMMYYYY")}</b></p>
                                            </div>
                                            <div>
                                                <p className="align-center"><u><b>INVOICE ADDRESS</b></u></p>
                                                <p style={{ textTransform: "uppercase" }}>{companyInfo.Name}</p>
                                                <p>{companyInfo.Address}</p>
                                                <p>Proforma Inv Ref : {TotalAmountAndCustomerPDFInfo.InvoiceNumber ? TotalAmountAndCustomerPDFInfo.InvoiceNumber : ""}</p>
                                                <p>Date : {moment(TotalAmountAndCustomerPDFInfo.CreatedDate).local().format("DD MMMM YYYY hh:mm:ss A")}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <hr></hr>
                                    <div className="row">
                                        <div className="col-md-12 align-left">
                                            <div style={{ paddingTop: "10px" }}>Sir,</div><div>
                                                Please acknowledge the receipt of this P.O. Kindly ensure the delivery as indicated.
                                                Please execute this P.O as per the terms and conditions below. If acknowledgment is not
                                                recieved within 2 daysit will be deemed that our P.O is accepted.
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row title" style={{ marginTop: "15px" }}>
                                <div className="col-md-12">
                                    <h5> Product Details</h5>
                                </div>
                                <div className="col-md-12">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "100px", backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-center InvoicePDFtitleStyle" >SI. No.</th>
                                                <th style={{ backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-center InvoicePDFtitleStyle">Product Details</th>
                                                <th style={{ width: "90px", backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-center InvoicePDFtitleStyle">Quantity</th>
                                                <th style={{ backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-center InvoicePDFtitleStyle">Rate</th>
                                                <th style={{ backgroundColor: (companyInfo.ThemeColor ? companyInfo.ThemeColor : "#c4f295") }} className="align-center InvoicePDFtitleStyle">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                ProductsPDFInfo.length > 0 && ProductsPDFInfo.map((pdfProduct, index) => (
                                                    <tr key={index + 1} className="align-center">
                                                        <td>{index + 1}</td>
                                                        <td className="align-center">{pdfProduct.Product.Name}</td>
                                                        {/* <td className="align-center">{pdfProduct.ProductGST} %</td> */}
                                                        <td className="align-center">{pdfProduct.ProductQuantity}</td>
                                                        <td className="align-center">{pdfProduct.ProductPrice.toFixed(2)}</td>
                                                        <td className="align-center">{(pdfProduct.ProductQuantity * pdfProduct.ProductPrice).toFixed(2)}</td>
                                                    </tr>
                                                ))
                                            }
                                            {
                                                <tr>
                                                    <td colSpan="4" className="align-center">{RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST"}</td>
                                                    <td className="align-center">
                                                        {(TotalAmountAndCustomerPDFInfo.TotalAmount - AmountwithoutGST).toFixed(2)}
                                                    </td>
                                                </tr>
                                            }
                                            {
                                                <tr>
                                                    <td colSpan="4" className="align-center">GRAND TOTAL</td>
                                                    <td className="align-center">
                                                        {TotalAmountAndCustomerPDFInfo.TotalAmount.toFixed(2)}
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-12 align-center" style={{ textTransform: "uppercase", paddingTop: "10px" }}>
                                    Grand total  : <span> {numberToEnglish(TotalAmountAndCustomerPDFInfo.TotalAmount.toFixed(2), companyInfo.CountryCode)} </span>

                                </div>
                            </div>

                            <div className="row title">

                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-3 col-sm-5">
                                            <b>Terms of Payment</b>
                                        </div>
                                        <div className="col-md-9 col-sm-7">
                                            <h6><input className="inputfocus" style={{ width: "100%", border: "none" }} onChange={(e) => onTypePaymentChange(e.target.value)} type="text" value={TypePaymentValue}></input></h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-3 col-sm-5">
                                            <b>Shipment Details</b>
                                        </div>
                                        <div className="col-md-9 col-sm-7">
                                            <h6><span style={{ textTransform: "uppercase" }}>{companyInfo.Name}</span>, {companyInfo.Address}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {TotalAmountAndCustomerPDFInfo.TermsAndConditions !== null && (<div className="row title">
                                <div className="col-md-12">
                                    <h6><b>Terms and Conditions</b></h6>
                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-9 col-sm-7">
                                            <h6>
                                                <ol>
                                                    {TotalAmountAndCustomerPDFInfo.TermsAndConditions.split('|').map((terms, index) => (
                                                        <li key={index}>
                                                            {terms}
                                                        </li>
                                                    ))}
                                                </ol>
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>)}
                            <div className="row title">
                                <div className="col-md-12">
                                    <div><b>Note : </b>The documents includeing Invoice, Packaging List, FTR, LR Test/Guarentee Certificates
                                        etc... If any (as applicable) shall be sent to  : {companyInfo.Address}</div>
                                    <div>for <b>{companyInfo.Name}</b></div>
                                </div>
                            </div>
                        </div>
                        {companyInfo.LogoHeader && (<div style={{ marginTop: "20px" }}>
                            <img alt="Permium" style={{ height: "12%", width: "100%" }} src={companyInfo.HeaderEqualFooter === 1 ? companyInfo.LogoHeader : companyInfo.LogoFooter}></img>
                        </div>)}
                    </div>
                </div></div>)}
            </div>
        </div>
    );
};

export default GeneratePO;